import { createApi } from '@reduxjs/toolkit/query/react';

import { API_URLS, REQUEST_METHOD } from 'constants/global';
import { IVote, PollOption } from 'constants/types';

import { baseQueryForumFormData } from './baseQuery';

export const voteManagement = createApi({
  reducerPath: 'voteApi',
  baseQuery: baseQueryForumFormData,
  endpoints: (builder) => ({
    vote: builder.mutation<void, IVote>({
      query: (voteData) => ({
        url: API_URLS.VOTE,
        method: REQUEST_METHOD.POST,
        body: voteData,
      }),
    }),
    checkIfVoted: builder.query<string[], string>({
      query: (pollId) => ({
        url: `${API_URLS.VOTE_CHECK}/${pollId}`,
        method: REQUEST_METHOD.GET,
      }),
    }),
    voteResults: builder.query({
      query: (pollId) => ({
        url: `${API_URLS.VOTE_RESULTS}/${pollId}`,
        method: REQUEST_METHOD.GET,
      }),
    }),
  }),
});

export const { useVoteMutation, useCheckIfVotedQuery, useVoteResultsQuery } =
  voteManagement;
